export enum DocumentStateChangeReason {
  /** Initial document loading. */
  Initialize = 'Initialize',
  /** Document is changed in the local editor. */
  Editor = 'Editor',
  /** Document is changed on the collab server. */
  Collab = 'Collab',
}
